// extracted by mini-css-extract-plugin
export default {"tx":"_4f9b926acf","line":"dc50771714"};